<template>
    <div class="d-flex align-items-center">
        <div class="avatars-w-50">
            <app-avatar
                :title="rowData.user.full_name"
                :img="''"
                :alt-text="rowData.user.full_name"
                :shadow="true"
            />
        </div>
        <div class="ml-3">
            <a v-if="$have('PERMISSION_VIEW_JOB_APPLICANT')"
               href="#"
               @click.prevent="passEvent">
                {{ rowData.user.full_name }}
            </a>
            <p v-else class="mb-0">
                {{ rowData.user.full_name }}
            </p>
            <p class="mb-0 font-size-90 text-muted">
                {{ rowData.user.email }}
            </p>
        </div>
    </div>
</template>

<script>

import AppFunction from "../../../core/helpers/app/AppFunction";

export default {
    name: 'TableMedia',
    props: {
        value: {},
        rowData: {},
        tableId: {},
    },
    methods: {
        passEvent() {
            location.replace(`/clients/${this.rowData.id}/details`);
        }
    }
}
</script>